import { connect, FormikValues } from 'formik'
import { useIntl } from 'react-intl'

import { FormLabel } from '@/components/StyledComponents'
import { StyledDateTimePicker } from '@/pages/SpaceAppBuilder/components/StyledComponents'

import { ScheduledIntervalType } from './interfaces'
import messages from './messages'

function Daily({ formik, readOnly = false }: ScheduledIntervalType & FormikValues) {
  const intl = useIntl()

  const { values, setFieldValue } = formik

  return (
    <>
      <FormLabel>{intl.formatMessage(messages.at)}</FormLabel>
      <StyledDateTimePicker
        readOnly={readOnly}
        name="triggerData.time"
        showTimeOnly={true}
        dateFormat="h:mm aa"
        placeholderText={intl.formatMessage(messages.pleaseSelectTime)}
        value={values.triggerData.time}
        onChange={setFieldValue}
        showIcon={true}
      />
    </>
  )
}

export default connect(Daily)
